module.exports = __webpack_public_path__ + "resources/icon_28_up.8024402c3162c34b.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_28_up.png
// module id = 351
// module chunks = 0 1 2 3 4